/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max length (0 = none)`)
};

const es_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitud máxima (0 = ninguna)`)
};

const de_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max. Länge (0 = keine)`)
};

const nl_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale lengte (0 = onbeperkt)`)
};

const fr_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longueur max (0 = aucune)`)
};

const it_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunghezza massima (0 = nessuno)`)
};

const pt_br2_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento máximo (0 = nenhum)`)
};

const pt_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento máximo (0 = sem limite)`)
};

const ja_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大文字数 (0 = なし)`)
};

const zh_sg_maxlength = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大长度（0 = 不限制）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_maxlength = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_maxlength(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_maxlength", locale)
	if (locale === "en") return en_sg_maxlength(inputs)
	if (locale === "es") return es_sg_maxlength(inputs)
	if (locale === "de") return de_sg_maxlength(inputs)
	if (locale === "nl") return nl_sg_maxlength(inputs)
	if (locale === "fr") return fr_sg_maxlength(inputs)
	if (locale === "it") return it_sg_maxlength(inputs)
	if (locale === "pt-BR") return pt_br2_sg_maxlength(inputs)
	if (locale === "pt") return pt_sg_maxlength(inputs)
	if (locale === "ja") return ja_sg_maxlength(inputs)
	return zh_sg_maxlength(inputs)
};